import { useReveal } from "../hooks/useReveal";
import { ABOUT_IMAGE } from "../data/content";
import { Check } from "lucide-react";

const HIGHLIGHTS = [
  "Design-first approach",
  "Complete customization",
  "Premium materials",
  "Expert installation",
  "Innovative surface technologies",
  "Tailored solutions for every client",
];

export default function About() {
  const ref = useReveal();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 lg:py-40 bg-[#FAFAFA]"
    >
      <div
        ref={ref}
        className="reveal max-w-[90rem] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start"
      >
        {/* Left column */}
        <div className="lg:col-span-7">
          <p className="overline mb-6 flex items-center gap-3">
            The Studio
          </p>
          <h2
            data-testid="about-headline"
            className="font-serif-display text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight text-stone-900"
          >
            Where your home becomes an
            <em className="italic text-[#4A6076]"> authentic reflection </em>
            of your narrative.
          </h2>

          <div className="mt-10 grid md:grid-cols-2 gap-6 text-stone-600 leading-relaxed text-[15px]">
            <p>
              Born from a rich background in large-scale commercial space design
              and strategic print execution, we have mastered the delicate
              balance between creative imagination and technical precision.
            </p>
            <p>
              Today we bring that elite touch of craftsmanship, scale and
              high-end aesthetics into the residential realm — curating private
              sanctuaries and immersive environments from the ground up.
            </p>
          </div>

          <ul className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
            {HIGHLIGHTS.map((h) => (
              <li
                key={h}
                data-testid={`about-highlight-${h.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="flex items-center gap-3 text-[15px] text-stone-800"
              >
                <span className="w-8 h-8 rounded-full border border-stone-300 flex items-center justify-center text-[#4A6076]">
                  <Check size={14} strokeWidth={1.5} />
                </span>
                {h}
              </li>
            ))}
          </ul>
        </div>

        {/* Right column - image + caption */}
        <div className="lg:col-span-5">
          <div className="img-zoom relative rounded-sm overflow-hidden aspect-[4/5] shadow-[0_20px_60px_rgba(0,0,0,0.08)]">
            <img
              src={ABOUT_IMAGE}
              alt="Modern luxury interior with sculpted architectural surfaces"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="mt-6">
            <p className="text-[13px] text-stone-500 leading-relaxed max-w-md">
              Chennai — India. A studio operating at the intersection of
              architecture, print and material craft.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
